module.exports = __webpack_public_path__ + "static/media/fly0282.2070bb78.webp";